import { render, staticRenderFns } from "./AdvancedSection.vue?vue&type=template&id=1c40d36e"
import script from "./AdvancedSection.vue?vue&type=script&lang=ts"
export * from "./AdvancedSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports